<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary" v-if="hasToken && user !== null">
      <router-link :to="{name: 'landing'}" class="navbar-brand">
        <h1>GDPR Control</h1>
      </router-link>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <div class="nav-item dropdown ml-auto">
          <span class="text-white">
            <strong>{{ user.email }}</strong>
          </span>

          <button type="button" class="btn btn-link text-white dropdown-toggle dropdown-toggle-split pl-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          </button>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <router-link :to="{name: 'passwordChange'}" tag="button" class="dropdown-item" type="button">Profil</router-link>
            <button class="dropdown-item" type="button" @click="logout">Kijelentkezés</button>
          </div>
        </div>
      </div>
    </nav>

    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import login from './views/auth/login'
import logout from './views/auth/logout'
import landing from './views/landing'

export default {
  name: 'App',

  components: {
    login,
    logout,
    landing
  },

  computed: {
    ...mapGetters({
      hasToken: 'auth/hasToken',
      getToken: 'auth/getToken',
      user: 'userDetails/getUserProfile'
    })
  },

  methods: {
    ...mapActions({
      fetchUserProfile: 'userDetails/fetchUserProfile',
      logout: 'auth/logout'
    }),

    events () {
      this.$router.push({name: 'event_list'})
    }
  },

  created () {
    if (this.hasToken && this.user === null) {
      this.fetchUserProfile()
    }
  },

  mounted () {
    if (this.$route.name !== 'login' && !this.hasToken) {
      this.$router.push({name: 'login'})
    } else {
      this.$router.push({name: 'landing'})
    }
  }
}
</script>

<style lang="styl">
  @import "assets/stylus/colors.styl";
  @import "assets/stylus/panels.styl";
</style>

<style scoped>
  nav {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue